<template>
    <el-dialog :title="title+'元数据'" width="50%" :close-on-click-modal="false" :visible.sync="visible">
        <el-form size="small" :model="form" ref="form" label-width="140px" :rules="dataRule" v-loading="loading"
                 :disabled="method==='view'"
                 @keyup.enter.native="doSubmit()" @submit.native.prevent>
            <el-descriptions title="基本信息"></el-descriptions>
            <el-form-item label="元数据名称：" prop="basicName">
                <el-input v-model.trim="form.basicName" placeholder="请输入元数据名称（限10字）" clearable
                          maxlength="10"></el-input>
            </el-form-item>
            <el-form-item label="元数据父级：" prop="basicParentId">
                <el-select v-model="form.basicParentId" placeholder="请选择元数据父级" class="w100i" filterable clearable @change="selBasicParent" :disabled="form.basicType == '0'">
                    <el-option
                            :key="item.id"
                            :label="item.basicName"
                            :value="item.id"
                            v-for="item in basicParentOpt">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="元数据类型：" prop="basicType">
                <el-select v-model="form.basicType" placeholder="请选择元数据类型" class="w100i" clearable
                           @change="selBasicType" :disabled="method!=='add'">
                    <el-option
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                            v-for="item in basicTypeOpt">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="组件类型：" prop="basicAssemblyId">
                <el-select v-model="form.basicAssemblyId" placeholder="请选择组件类型" filterable class="w100i" clearable
                           @focus="selBasicAssembly" :disabled="method!=='add'">
                    <el-option
                            :key="item.id"
                            :label="item.assemblyName"
                            :value="item.id"
                            v-for="item in basicAssemblyOpt">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否显示：" prop="basicEnable">
                <el-switch v-model="form.basicEnable" active-value="0" inactive-value="1"></el-switch>
            </el-form-item>
            <el-descriptions title="其他信息"></el-descriptions>
            <el-form-item label="主机信息：" prop="basicSystem">
                <el-input v-model.trim="form.basicSystem" placeholder="请输入主机信息（限50字）" clearable
                          maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="数据库信息：" prop="basicDatabase">
                <el-input v-model.trim="form.basicDatabase" placeholder="请输入数据库信息（限50字）" clearable
                          maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="用户信息：" prop="basicUserInfo">
                <el-input v-model.trim="form.basicUserInfo" placeholder="请输入用户信息（限50字）" clearable
                          maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="数据对象信息：" prop="basicObjectInfo">
                <el-input v-model.trim="form.basicObjectInfo" placeholder="请输入数据对象信息（限50字）" clearable
                          maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="加工逻辑：" prop="basicProcessingLogic">
                <el-input v-model.trim="form.basicProcessingLogic" placeholder="请输入加工逻辑（限50字）" clearable
                          maxlength="50"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button size="small" @click="visible = false">{{ method == 'view' ? '关闭' : '取消' }}</el-button>
            <el-button size="small" type="primary" :disabled="loading" v-if="method != 'view'" @click="doSubmit()" v-noMoreClick>保存
            </el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        data() {
            return {
                visible: false,
                loading: false,
                title: '',
                method: '',
                basicParentOpt: [],
                basicTypeOpt: [],
                basicAssemblyOpt: [],
                basicAssemblyAllOpt: [],
                form: {
                    id: "",
                    basicName: "",
                    basicParentId: "",
                    basicType: "",
                    basicAssemblyId: "",
                    basicEnable: "0",
                    basicSystem: "",
                    basicDatabase: "",
                    basicUserInfo: "",
                    basicObjectInfo: "",
                    basicProcessingLogic: "",
                },
                dataRule: {
                    basicName: [
                        {required: true, message: '元数据名称不能为空', trigger: 'blur'}
                    ],
                    basicType: [
                        {required: true, message: '元数据类型不能为空', trigger: 'change'}
                    ],
                    basicAssemblyId: [
                        {required: true, message: '组件类型不能为空', trigger: 'change'}
                    ],
                }
            }
        },
        methods: {
            // 初始化数据
            init(row, method) {
                this.basicTypeOpt = this.$dictUtils.getDictList('basic_type')
                this.method = method
                if (method === 'add') {
                    this.title = `新增`
                } else if (method === 'edit') {
                    this.title = '修改'
                } else if (method === 'view') {
                    this.title = '查看'
                }
                if (row) {
                    this.form.id = row.id
                } else {
                    this.form.id = ''
                }
                this.visible = true
                this.$nextTick(() => {
                    this.$refs.form.resetFields();
                    this.getAllDimension()
                })
            },
            // 查询详情信息
            getInfo() {
                this.loading = true
                this.$axios(this.api.metadata.getById + '/' + this.form.id).then(res => {
                    if (res.status) {
                        this.form = this.recover(this.form, res.data);
                        this.selBasicParent(this.form.basicParentId)
                        this.selBasicType(this.form.basicType, 1)
                    }
                    this.loading = false
                })
            },
            // 查询元数据父级
            getAllDimension() {
                this.loading = true
                this.$axios(this.api.metadata.selectAllDimension).then(res => {
                    if (res.status) {
                        this.basicParentOpt = res.data.filter(v => v.id != this.form.id)
                        this.getBasicAssembly()
                    }
                })
            },
            // 获取组件类型
            getBasicAssembly() {
                this.$axios(this.api.metadata.selectAllMetadataBasicAssembly).then(res => {
                    if (res.status) {
                        this.basicAssemblyAllOpt = res.data.filter(v=> {return v.id != '19' && v.id != '20'})
                        if (this.method != 'add') {
                            this.getInfo()
                        }
                    }
                    this.loading = false
                })
            },
            // 选择元数据父级
            selBasicParent(val) {
                if(val) {
                    let item = this.basicParentOpt.filter(v => v.id == val)[0]
                    this.basicTypeOpt = this.basicTypeOpt.filter(v => v.value != item.basicType)
                } else {
                    this.basicTypeOpt = this.$dictUtils.getDictList('basic_type')
                }
            },
            // 选择元数据类型  type数据回显
            selBasicType(val, type) {
                this.basicAssemblyOpt = []
                if(!type) {
                    this.form.basicAssemblyId = ''
                }
                if (val == '0') {
                    this.basicAssemblyOpt = this.basicAssemblyAllOpt.filter(v=> {return v.id == '18'})
                    this.form.basicParentId = ''
                } else if(val == '1') {
                    this.basicAssemblyOpt = this.basicAssemblyAllOpt.filter(v=> {return v.id != '18'})
                }
                if (this.method != 'add' && type) {
                    this.form = this.recover(this.form, this.form);
                }
            },
            // 选择组件类型
            selBasicAssembly() {
                if (!this.form.basicType) {
                    this.$message.warning('请先选择元数据类型')
                }
            },
            // 表单提交
            doSubmit() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.loading = true
                        let api = this.api.metadata.save, type = 'post'
                        if (this.method === 'edit') {  // 新增
                            api = this.api.metadata.updateById
                            type = 'put'
                        }
                        let p = JSON.parse(JSON.stringify(this.form))
                        if(!p.basicParentId) {
                            p.basicParentId = null
                        }
                        this.$axios(api, p, type).then(data => {
                            if (data.status) {
                                this.$message.success('保存成功')
                                this.visible = false
                                this.$emit('refreshDataList')
                            } else {
                                this.$message.error(data.msg)
                            }
                            this.loading = false
                        })
                    }
                })
            },
        }
    }
</script>
